// extracted by mini-css-extract-plugin
export default {"root":"ProgressBar_root_dIRuh","progressBar":"ProgressBar_progressBar_N9HB2"};